// extracted by mini-css-extract-plugin
export default {"borrowerMessage":"PlaceOfferSection-module__borrowerMessage--CPdDf"};